import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const Navbar = ({ onNavigate }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleNavigation = (page) => {
    onNavigate(page);
    setDropdownOpen(false);
  };

  return (
    <nav className="bg-white border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <button onClick={() => onNavigate('home')} className="flex items-center">
          
            </button>
          </div>
         
        </div>
      </div>
    </nav>
  );
};

export default Navbar;